/**
 * Domain Event Buffer — 当前 Tick 的已编号事件，只追加。
 * 事件是已发生的事实，供 UI/音频/场景/统计/测试消费，但不反向成为权威状态。
 */

import type { RecordedEvent } from './context.js';

export class DomainEventBuffer {
  private readonly events: RecordedEvent[] = [];

  /** 追加一个已完整编号的事件。 */
  append(event: RecordedEvent): void {
    this.events.push(event);
  }

  /** 当前缓冲中的事件（只读副本）。 */
  all(): readonly RecordedEvent[] {
    return this.events.slice();
  }

  get length(): number {
    return this.events.length;
  }

  /** Tick 结束时清空，为下一 Tick 准备。 */
  clear(): void {
    this.events.length = 0;
  }
}
